export const columnsDataSubjects = [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "Materia",
    accessor: "description",
  },
  {
    Header: "Ciclo",
    accessor: "cycle",
  },
  {
    Header: "Plan",
    accessor: "studyPlan.description",
  },
  {
    Header: "Estudio",
    accessor: "study.description",
  },
    {
    Header: "Práctico",
    accessor: "practic",
  },
    {
    Header: "Obligatorio",
    accessor: "obligatory",
  },
];
